module.exports = __webpack_public_path__ + "static/img/pillowcase.4d91718.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pillowcase.jpg
// module id = 218
// module chunks = 1